import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserAccess } from '../hooks/useUserAccess';

function AdmcenGuard({ children }) {
  const { canAccessAdmcen, loading } = useUserAccess();

  if (loading) {
    return (
      <div className="status-card" style={{ textAlign: 'center', padding: 40 }}>
        <span className="status-title">Verificando permissões...</span>
      </div>
    );
  }

  if (!canAccessAdmcen) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdmcenGuard;
